module.exports = __webpack_public_path__ + "static/media/31.c24251a9.jpeg";